export const getPrimaryDomain = (hostname: string) => {
  const domainParts = hostname.split(".");
  const length = domainParts.length;

  if (length > 2) {
    // Assuming there is a subdomain and return only the primary domain
    return domainParts[length - 2] + "." + domainParts[length - 1];
  }

  return hostname;
};
